var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-summit-step-background step"},[_c('div',{staticClass:"q-summit-step-background__image"},[_c('QSummitStepBackgroundBottom',{staticClass:"q-summit-step-background__bottom"}),_c('QSummitStepBackgroundClouds',{staticClass:"q-summit-step-background__clouds"})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }